import React, { Component, Fragment } from 'react';
import { Card, Icon } from 'antd';
import { inject, observer } from 'mobx-react';
import { AddStopDialog } from './AddStopDialog';

@inject('store')
@observer
export class CandleChart extends Component {
    constructor(props) {
        super(props);
        this.init = false;
        this.entryLayers = {};
        this.exitOrders = {};
        this.state = {
            showAddStopDialog: false,
            stopPrice: 0
        };
    }
    componentDidMount() {
        const store = this.props.store;
        const { currentUser } = store.userStore;

        this.widget = new window.TradingView.widget({
            //debug: true, // uncomment this line to see Library errors and warnings in the console
            fullscreen: false,
            symbol: this.props.symbol,
            interval: '5',
            container_id: 'chart',
            datafeed: {
                onReady(cb) {
                    cb();
                },

                resolveSymbol(symbolName, onSymbolResolvedCallback, onResolveErrorCallback) {
                    onSymbolResolvedCallback({
                        name: symbolName,
                        supported_resolutions: [
                            '1',
                            '3',
                            '5',
                            '15',
                            '30',
                            '60',
                            '120',
                            '240',
                            '360',
                            '720',
                            'D'
                        ],
                        has_intraday: true,
                        minmov: 1,
                        pricescale:
                            symbolName === 'XRP/USD' || symbolName === 'EOS/USD' ? 10000 : 100
                    });
                },
                getBars: async (
                    symbolInfo,
                    resolution,
                    from,
                    to,
                    onHistoryCallback,
                    onErrorCallback,
                    firstDataRequest
                ) => {
                    const candles = await store.makoBotStore.getKline(
                        symbolInfo.name.replace('/', ''),
                        resolution,
                        from,
                        to
                    );
                    onHistoryCallback(candles);
                },
                subscribeBars: async (
                    symbolInfo,
                    resolution,
                    onRealtimeCallback,
                    subscriberUID,
                    onResetCacheNeededCallback
                ) => {
                    store.makoBotStore.streamKline(symbolInfo.name.replace('/', ''), resolution);
                    store.makoBotStore.socket.on('kline', ({ data }) => {
                        onRealtimeCallback(data);
                    });
                },
                unsubscribeBars(subscriberUID) {
                    //noop
                }
            },

            library_path: '/charting_library/',
            locale: 'en',
            disabled_features: [
                'study_templates',
                'header_symbol_search',
                'header_compare',
                'compare_symbol',
                'header_saveload',
                'header_indicators',
                'study_templates',
                'header_symbol_search',
                'header_undo_redo',
                'scales_context_menu',
                'main_series_scale_menu'
            ],
            enabled_features: [],
            charts_storage_url: 'http://saveload.tradingview.com',
            charts_storage_api_version: '1.1',
            client_id: 'apextrader.io',
            user_id: currentUser.uid,
            autosize: true,
            theme: 'dark',
            load_last_chart: false
        });

        this.widget.headerReady().then(() => {
            const button = this.widget.createButton();
            button.setAttribute('title', 'Add Layer');
            button.addEventListener('click', () => {
                this.props.addLayerRequest(0);
            });
            button.textContent = 'Add Layer';

            // const button2 = this.widget.createButton();
            // button2.setAttribute('title', 'Add Stop');
            // button2.addEventListener('click', () => {
            //     this.setState({
            //         showAddStopDialog: true
            //     });
            // });
            // button2.textContent = 'Add Stop';
        });

        this.widget.onChartReady(() => {
            this.widget
                .chart()
                .createStudy('Moving Average Exponential', false, false, [10, 'close'], null, {
                    'Plot.linewidth': 1,
                    'Plot.color': '#7fffd4'
                });

            this.widget.onContextMenu((unixtime, price) => {
                let formatedPrice = price.toFixed(2);
                if (this.props.symbol === 'XRP/USD') {
                    formatedPrice = price.toFixed(4);
                }
                return [
                    {
                        position: 'top',
                        text: 'Add Layer: Price: ' + formatedPrice,
                        click: () => {
                            this.props.addLayerRequest(formatedPrice);
                        }
                    },
                    // {
                    //     position: 'top',
                    //     text: 'Add Stop: Price: ' + price.toFixed(4),
                    //     click: () => {
                    //         this.setState({
                    //             showAddStopDialog: true,
                    //             stopPrice: price.toFixed(4)
                    //         });
                    //     }
                    // },
                    { text: '-Lock Vertical Line On Time Axis' },
                    { text: '-Remove All Indicators' },
                    { text: '-Remove All Drawing Tools' },
                    { text: '-Object Tree...' },
                    { text: '-Insert Indicator...' },
                    { text: '-Go to Date...' },
                    { text: '-Symbol Info...' },
                    { text: '-Change Interval...' },
                    { text: '-Change Symbol...' },
                    { text: '-Drawing Tools' },
                    { text: '-Lock Cursor in Time' },
                    { text: '-Hide Marks on Bars' },
                    { text: '-Remove' },
                    { text: '-Price Scale' },
                    { text: '-Time Scale' },
                    { text: '-Properties...' }
                ];
            });
            this.init = true;
        });
    }

    updateOrderLines(position) {
        if (!this.init) return;
        const { store } = this.props;
        const self = this;
        if (!position) {
            try {
                this.entry && this.entry.remove();
                this.stopLoss && this.stopLoss.remove();
                this.entry = null;
                this.stopLoss = null;
                Object.values(this.entryLayers).forEach(artifact => artifact.remove());
                this.entryLayers = {};
                Object.values(this.exitOrders).forEach(artifact => artifact.remove());
                this.exitOrders = {};
            } catch (e) {
                console.log(e);
            }
            return;
        }

        try {
            this.widget.onChartReady(() => {
                if (this.entry && position) {
                    this.entry
                        .setText(`${position.side === 'BUY' ? 'LONG' : 'SHORT'} ENTRY`)
                        .setQuantity(position.qty)
                        .setPrice(position.avg_entry);
                } else if (position) {
                    this.entry = this.widget
                        .chart()
                        .createPositionLine()
                        .setText(`${position.side === 'BUY' ? 'LONG' : 'SHORT'} ENTRY`)
                        .setQuantity(position.entry_order_filled)
                        .setLineLength(3)
                        .setPrice(position.avg_entry)
                        .setBodyBackgroundColor('#222437')
                        .setBodyTextColor('#4894E8');
                } else {
                    this.entry && this.entry.remove();
                }

                if (
                    this.stopLoss &&
                    position &&
                    position.stop_loss != null &&
                    position.stop_loss.qty
                ) {
                    this.stopLoss
                        .setText(`STOP LOSS`)
                        .setQuantity(position.stop_loss.qty)
                        .setPrice(position.stop_loss.stop_px);
                } else if (position && position && position.stop_loss != null) {
                    this.stopLoss = this.widget
                        .chart()
                        .createPositionLine()
                        .setText(`STOP LOSS`)
                        .setQuantity(position.stop_loss.qty)
                        .setLineLength(3)
                        .setPrice(position.stop_loss.stop_px)
                        .setLineColor('#ff3366')
                        .setBodyBorderColor('#ff3366')
                        .setBodyTextColor('#ff3366')
                        .setQuantityBorderColor('#ff3366')
                        .setQuantityBackgroundColor('#ff3366')
                        .setBodyBackgroundColor('#222437');
                } else {
                    this.stopLoss && this.stopLoss.remove();
                }

                const exitOrders = position.exit_orders;
                const entryLayers = position.layers.filter(l => l.status === 'PLACED');
                const filledEntryLayers = position.layers.filter(l => l.status === 'FILLED');

                position.layers.forEach(layer => {
                    if (layer.status === 'PLACED' && !this.entryLayers[layer.order.id]) {
                        if (!this.widget) return;

                        this.entryLayers[layer.order.id] = this.widget
                            .chart()
                            .createOrderLine()
                            .setText(`LAYER: ${layer.price}`)
                            .setQuantity(layer.qty)
                            .setLineLength(3)
                            .setPrice(layer.price)
                            .setLineColor('#29c0b1')
                            .setBodyBorderColor('#29c0b1')
                            .setBodyTextColor('#29c0b1')
                            .setQuantityBorderColor('#29c0b1')
                            .setQuantityBackgroundColor('#29c0b1')
                            .setBodyBackgroundColor('#222437')
                            .setQuantityTextColor('#222437')
                            .setCancelButtonBackgroundColor('#ff3366')
                            .setCancelButtonIconColor('#ff3366')
                            .setCancelButtonIconColor('#ffffff')
                            .onModify(function(data, cb) {
                                //noop allows on move to work
                            })
                            .onCancel(function() {
                                store.makoBotStore.cancelEntryLayer(layer.order.id);
                                self.entryLayers[layer.order.id].remove();
                            })
                            .onMove(function() {
                                store.makoBotStore.updateEntryLayer(
                                    layer.order.id,
                                    this.getPrice()
                                );
                                self.entryLayers[layer.order.id].remove();
                            });
                    } else if (layer.status !== 'PLACED' && this.entryLayers[layer.order.id]) {
                        this.entryLayers[layer.order.id].remove();
                        delete this.entryLayers[layer.order.id];
                    }
                });

                exitOrders.forEach(order => {
                    if (!this.exitOrders[order.id] && order.status === 'open') {
                        this.exitOrders[order.id] = this.widget
                            .chart()
                            .createOrderLine()
                            .setText(`TP: ${order.price}`)
                            .setQuantity(order.info.qty)
                            .setLineLength(3)
                            .setPrice(order.price)
                            .setLineColor('#ff3366')
                            .setBodyBorderColor('#ff3366')
                            .setBodyTextColor('#ff3366')
                            .setQuantityBorderColor('#ff3366')
                            .setQuantityBackgroundColor('#ff3366')
                            .setBodyBackgroundColor('#222437')
                            .onModify(function(data, cb) {
                                //noop allows on move to work
                            })
                            .onMove(function() {
                                store.makoBotStore.updateExitLayer(order.id, this.getPrice());
                                this.exitOrders[order.id].setPrice(this.getPrice());
                            });
                    }
                    if (order.status !== 'open' && this.exitOrders[order.id]) {
                        this.exitOrders[order.id] && this.exitOrders[order.id].remove();
                        delete this.exitOrders[order.id];
                    }
                });
            });
        } catch (e) {
            console.log('Error in chart', e.stack);
        }
    }

    render() {
        const { position, ticker, direction, tzone } = this.props.store.makoBotStore;

        this.updateOrderLines(position);

        const extra = ticker ? (
            <ul className={'ticker'}>
                <li>
                    <p className="title">Direction</p>
                    <p
                        className={
                            direction === 'long'
                                ? 'success'
                                : direction === 'short'
                                ? 'error'
                                : null
                        }
                    >
                        {direction === 'long' ? (
                            <Fragment>
                                <Icon type="arrow-up" theme="outlined" className="connected" /> Long{' '}
                            </Fragment>
                        ) : direction === 'short' ? (
                            <Fragment>
                                <Icon type="arrow-down" theme="outlined" className="error" /> Short
                            </Fragment>
                        ) : (
                            <Fragment>
                                <Icon type="minus" theme="outlined" /> None
                            </Fragment>
                        )}
                    </p>
                </li>
                <li>
                    <p className="title">Trading Zone %</p>
                    <p className={tzone >= 0 ? 'success' : 'error'}>{tzone.toFixed(2)}%</p>
                </li>
                <li>
                    <p className="title">Last Price</p>
                    <p className={ticker.percentage > 0 ? 'success' : 'error'}>
                        {ticker.last.toFixed(2)}
                    </p>
                </li>
                <li>
                    <p className="title">24h Change</p>
                    <p className={ticker.percentage > 0 ? 'success' : 'error'}>
                        {(ticker.percentage * 100).toFixed(2)}%
                    </p>
                </li>
                <li>
                    <p className="title">24h High</p>
                    <p>{ticker.high}</p>
                </li>
                <li>
                    <p className="title">24h Low</p>
                    <p>{ticker.low}</p>
                </li>
                <li>
                    <p className="title">24h Turnover</p>
                    <p>{ticker.baseVolume}</p>
                </li>
                <li>
                    <p className="title">Funding in {ticker.info.countdown_hour} hours</p>
                    <p>{ticker.info.funding_rate}%</p>
                </li>
            </ul>
        ) : null;
        return (
            <Card
                title={this.props.symbol}
                size={'small'}
                bordered={false}
                extra={extra}
                style={{ height: 850, marginBottom: 15 }}
                bodyStyle={{ height: '100%' }}
            >
                <div id="chart" style={{ height: '93%' }} />

                <AddStopDialog
                    price={this.state.stopPrice}
                    visible={this.state.showAddStopDialog}
                    close={() => this.setState({ showAddStopDialog: false })}
                />
            </Card>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Account/MakoBot/TradeView/Chart.js